import { gateBooleanToBoolean, gateNonstandardDateToDate } from "../utils/GateSupport"


export type IApiDBRecord = {
    created: Date | null
    deleted: boolean,
    modified: Date | null
}


export type IApiDBRecordDTO = {
    created: string
    deleted: "Y" | "N",
    modified: string
}



export const ApiDBRecordMapper = {
    apiToDomain: (api: IApiDBRecordDTO): IApiDBRecord => {
        return {
            created: api.created ? gateNonstandardDateToDate(api.created) : null,
            deleted: gateBooleanToBoolean(api.deleted),
            modified: api.created ? gateNonstandardDateToDate(api.created) : null
        }
    }
}
